import React, { useState } from "react";
import { BASE_URL } from "../../constant/constant";
import Button from "../../components/FormComponents/Button";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";

const formatSize = (bytes) => {
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

const initialModalState = {
  isOpen: false,
  data: null
};

const FileRepoTable = ({ files, onEdit, onDelete }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(initialModalState);
  const openModal = (data) => {
    setIsEditModalOpen({
      isOpen: true,
      data
    });
  };
  const closeModal = () => {
    setIsEditModalOpen(initialModalState);
  };

  const handleEditFile = (newFile) => {
    onEdit(isEditModalOpen.data.id, newFile);
    closeModal();
  };

  if (!files.length) return <h2 className="w_100 h_100 d_flex align_center justify_center">No files available.</h2>;

  return (
    <div className="py_3">
      <h2>Files</h2>
      <table>
        <thead>
          <tr>
            <th>File Name</th>
            <th>Original Name</th>
            {/*<th>Type</th>*/}
            <th>Size</th>
            <th>Description</th>
            <th>Download</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {files.map((file, index) => {
            const { file_data, name, description } = file;
            const previewUrl = `${BASE_URL}/api/v1/public/${file_data.name}`;

            return (
              <tr key={file_data.file_id || index}>
                <td>{name}</td>
                <td>{file_data.original_name}</td>
                {/*<td>{file_data.type}</td>*/}
                <td>{formatSize(file_data.size)}</td>
                <td>{description}</td>
                <td>
                  <a href={previewUrl} target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                </td>
                <td className={"d_flex gap_2"}>
                  <Button variant="secondary" onClick={() => openModal(file)}>
                    <MaterialIcon name="edit" />
                  </Button>
                  <Button variant="delete" onClick={() => onDelete(file.id)}>
                    <MaterialIcon name="delete" />
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <BuilderModal isOpen={isEditModalOpen.isOpen} modalName={"Edit File"} onClose={closeModal}>
        <EditFileRepo data={isEditModalOpen.data} onEdit={handleEditFile} />
      </BuilderModal>
    </div>
  );
};

const EditFileRepo = ({ data, onEdit }) => {
  const [editData, setEditData] = useState({
    name: data.name,
    description: data.description
  });

  const handleChangeInput = (e) => setEditData({ ...editData, [e.target.name]: e.target.value });

  const handleEdit = () => {
    onEdit(editData);
  };

  return (
    <div className={"builder_form"}>
      <Input
        label={"File Name"}
        value={editData.name}
        name={"name"}
        placeholder={"Enter File Name"}
        onChange={handleChangeInput}
      />
      <Textarea
        label={"File Description"}
        value={editData.description}
        name={"description"}
        placeholder={"Enter File Description"}
        onChange={handleChangeInput}
      />
      <Button onClick={handleEdit}>Edit</Button>
    </div>
  );
};

export default FileRepoTable;
